import { render, staticRenderFns } from "./ListaMovimento.vue?vue&type=template&id=f121316e&scoped=true&"
import script from "./ListaMovimento.vue?vue&type=script&lang=js&"
export * from "./ListaMovimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f121316e",
  null
  
)

export default component.exports